export default "__VITE_ASSET__DdQ3B7BV__"